export default __webpack_public_path__ + "static/media/PennyPincher.2f86ec3b.png";